angular.module('jv.search.collection.service', [])
.service('jvSearchCollectionService', [
    '$http', '$q',
    function($http, $q) {
        var baseUrl = jvUrls.jhire + '/action/application/collection';
        this.list = function(maxResults, page, keywords) {
            return $http.get([baseUrl, 'list'].join('/'), {
                params: {
                    maxResults: maxResults || 0,
                    page: page || 0,
                    keywords: keywords || ''
                }
            }).then(function(response) {
                if (!response.data) {
                    return $q.reject();
                }
                return response.data;
            });
        };
        this.delete = function(eid) {
        	return $http.delete([baseUrl, eid].join('/')).then(function(response) {
                if (!response.data) {
                    return $q.reject();
                }
                return response.data;
            });
        }
        
    }
]);